import React from 'react';

import differenceBy from 'lodash/differenceBy';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import {
    STATE_AVAIL_MAP,
} from '@src/global/linkConstants';
import { SafelyRenderHtml } from '@src/services';

import Availability from './Availability';

const RenderAvailability = (props) => {
    const {
        allStates,
        comingSoonStates = [],
        isNew,
        slug,
        states,
    } = props;

    const remainingStates = allStates.length - states.length;
    const stateAvailabilityLink = <Link to={`${STATE_AVAIL_MAP}/${slug}`} className="link-primary">View Availability Map <span className="visually-hidden"> Link</span></Link>;
    const agent360AvailabilityMapLink = <Link to={`${STATE_AVAIL_MAP}/${slug}`} className="link-primary">Agent360 Availability Map <span className="visually-hidden"> Link</span></Link>;

    const renderComingSoonStates = () => {
        if (!comingSoonStates || comingSoonStates.length === 0) {
            return null;
        }

        return (
            <p>
                {SafelyRenderHtml('Coming soon in the following states:&#32;')}
                {
                    comingSoonStates.map((state, i) => {
                        return (
                            <React.Fragment key={state.id || state.slug || state.abbreviation || i}>
                                {comingSoonStates.length - 1 === i ? `${state.abbreviation}` : SafelyRenderHtml(`${state.abbreviation},&#32;`)}
                            </React.Fragment>
                        );
                    })
                }
            </p>
        );
    };

    if (isNew) {
        return (
            <p className="pb-4">To view availability for Agent360 supported products, visit the {agent360AvailabilityMapLink}.</p>
        );
    }

    if (remainingStates === 0) {
        return <p>Available in all states: {stateAvailabilityLink}</p>;
    }

    if (remainingStates < 10) {
        return (
            <Availability mapLink={stateAvailabilityLink}>
                <p>
                    {SafelyRenderHtml('Available in all states except:&#32;')}
                    {
                        differenceBy(allStates, states, 'slug').map((state, i) => {
                            return (
                                <React.Fragment key={state.id}>
                                    {remainingStates - 1 === i ? `${state.abbreviation}` : SafelyRenderHtml(`${state.abbreviation},&#32;`)}
                                </React.Fragment>
                            );
                        })
                    }
                </p>
                {renderComingSoonStates()}
            </Availability>
        );
    }

    return (
        <Availability mapLink={stateAvailabilityLink}>
            {
                states && states.length > 0 && (
                    <p>
                        {SafelyRenderHtml('Available in the following states:&#32;')}
                        {
                            states.map((state, i) => {
                                return (
                                    <React.Fragment key={state.id}>
                                        {states.length - 1 === i ? `${state.abbreviation}` : SafelyRenderHtml(`${state.abbreviation},&#32;`)}
                                    </React.Fragment>
                                );
                            })
                        }
                    </p>
                )
            }
            {renderComingSoonStates()}
        </Availability>
    );
};

RenderAvailability.propTypes = {
    allStates: PropTypes.array,
    comingSoonStates: PropTypes.array,
    isNew: PropTypes.bool,
    slug: PropTypes.string,
    states: PropTypes.array,
};

export default RenderAvailability;
